import React from 'react';
import { motion } from 'framer-motion';
import { VisionVisual } from './ui/AbstractVisuals';
import { ArrowRight } from 'lucide-react';
export function VisionSection() {
  return <section className="py-24 px-4 relative" data-id="element-153">
      <div className="max-w-7xl mx-auto" data-id="element-154">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-155">
          {/* Visual Side */}
          <div className="order-2 lg:order-1 relative" data-id="element-156">
            <div className="absolute inset-0 bg-gradient-to-r from-neon-cyan/5 to-electric-violet/5 rounded-full blur-3xl" data-id="element-157" />
            <VisionVisual data-id="element-158" />
          </div>

          {/* Text Side */}
          <div className="order-1 lg:order-2 space-y-8" data-id="element-159">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-6xl font-bold text-white leading-tight" data-id="element-160">
              Sadece Kod Değil, <br data-id="element-161" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-cyan to-electric-violet" data-id="element-162">
                Değer Üretiyoruz.
              </span>
            </motion.h2>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-lg text-gray-400 leading-relaxed" data-id="element-163">
              Mükemmel bir yazılım, eğer hayatı kolaylaştırmıyorsa sadece satır
              yığınından ibarettir. Biz, mühendislik disiplinini girişimci
              ruhuyla birleştiriyoruz. Sadece 'çalışan' değil, 'sevilen ve
              kullanılan' platformlar inşa ediyoruz.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} className="flex items-center gap-4 pt-4" data-id="element-164">
              <div className="px-6 py-3 rounded-xl bg-white/5 border border-white/10" data-id="element-165">
                <span className="text-white font-semibold" data-id="element-166">Hayal Et</span>
              </div>
              <ArrowRight className="w-6 h-6 text-neon-cyan" data-id="element-167" />
              <div className="px-6 py-3 rounded-xl bg-white/5 border border-white/10" data-id="element-168">
                <span className="text-white font-semibold" data-id="element-169">Tasarla</span>
              </div>
              <ArrowRight className="w-6 h-6 text-electric-violet" data-id="element-170" />
              <div className="px-6 py-3 rounded-xl bg-white/10 border border-neon-cyan/30" data-id="element-171">
                <span className="text-white font-semibold" data-id="element-172">Uygula</span>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}